import backend from 'network/BackendFetchAdapter';
import { MealTemplateDetail } from 'types/types';

export const mealApi = {
  getMealDetail: (mealId: string): Promise<MealTemplateDetail> => backend.fetchJson(`/api/meals/${mealId}`),
};
